module.exports = __webpack_public_path__ + "img/backArrow.png?6f2f8054eb48e440104b1694ed6a07ff";